module.exports = __webpack_public_path__ + "static/media/pic-sales_main.57830551.svg";